export const SAML_METADATA_URL = 'https://api.mybiteshares.com/api/sso/metadata';
export const BEEKEEPER_ORGS: { [orgId: string]: { authUrl: string } } = {
  '11363': {
    authUrl: 'https://leonardo.beekeeper.io/auth_link',
  },
};
